// extracted by mini-css-extract-plugin
module.exports = {"breakpointMD":"750px","breakpointLG":"1250px","breakpointXL":"1800px","subscribe":"Newsletter-module--subscribe--2II7t","loading":"Newsletter-module--loading--1clAd"};